module.exports = __webpack_public_path__ + "img/ten-T.d76991fe.webp";